module.exports = __webpack_public_path__ + "static/media/icone-play.9a263b56.svg";